export const customObjects = [
  {data: "🎁", category: "Objects", aliases: ["gift"]},
  {data: "🎈", category: "Objects", aliases: ["balloon"]},
  {data: "🎊", category: "Objects", aliases: ["confetti_ball"]},
  {data: "🎉", category: "Objects", aliases: ["tada"]}
]